var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4286 18.469C20.4286 18.0542 20.3194 17.6471 20.1119 17.2881C20.1111 17.2865 20.1104 17.2849 20.1088 17.2834C15.7803 9.92594 4.64907 9.93379 0.325287 17.2865C0.324501 17.2881 0.322928 17.2904 0.322928 17.2904C0.117071 17.6464 0.00785669 18.0494 0.00628526 18.4596C-4.55882e-07 18.7652 0 19.2036 0 19.6429C0 20.2683 0.248287 20.8678 0.690644 21.3094C1.13222 21.7517 1.73171 22 2.35714 22C5.90857 22 14.52 22 18.0714 22C18.6969 22 19.2964 21.7517 19.7379 21.3094C20.1803 20.8678 20.4286 20.2683 20.4286 19.6429V18.469ZM10.2143 0C7.17907 0 4.71429 2.46479 4.71429 5.5C4.71429 8.53521 7.17907 11 10.2143 11C13.2495 11 15.7143 8.53521 15.7143 5.5C15.7143 2.46479 13.2495 0 10.2143 0Z",
    fill: "#A9A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUserIcon);
export default __webpack_public_path__ + "static/media/ProfileUserIcon.e51d7fd8a03d2f1f85cbcc4a9a1c7f64.svg";
export { ForwardRef as ReactComponent };